import React from 'react';
import { Layout } from '../components/Layout';

const TermsPage = () => {
  return (
    <Layout>
      <div className="py-12 md:py-20">
        <div className="max-w-[900px] mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-semibold text-black mb-4" data-testid="terms-title">
            Terms of Use
          </h1>
          <p className="text-base text-[#333333] mb-16">
            Last updated: February 22, 2026
          </p>

          <div className="space-y-12">
            <div>
              <p className="text-base md:text-lg leading-relaxed text-[#333333]">
                By using AI Atlas, you agree to the following:
              </p>
            </div>

            <section>
              <h2 className="text-3xl md:text-4xl font-semibold text-black mb-4">
                1. Informational Purpose
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-[#333333]">
                AI Atlas provides information and comparisons about AI tools for general guidance only.
              </p>
            </section>

            <section>
              <h2 className="text-3xl md:text-4xl font-semibold text-black mb-4">
                2. No Professional Advice
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-[#333333]">
                The content on this website is not professional, legal, financial, or technical advice.
              </p>
            </section>

            <section>
              <h2 className="text-3xl md:text-4xl font-semibold text-black mb-4">
                3. Third-Party Tools
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-[#333333]">
                AI Atlas links to third-party websites and tools. We are not responsible for their performance, content, security, or policies.
              </p>
            </section>

            <section>
              <h2 className="text-3xl md:text-4xl font-semibold text-black mb-4">
                4. Limitation of Liability
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-[#333333]">
                AI Atlas is not liable for any loss, damage, or issues arising from the use of tools listed on this website.
              </p>
            </section>

            <section>
              <h2 className="text-3xl md:text-4xl font-semibold text-black mb-4">
                5. Changes
              </h2>
              <p className="text-base md:text-lg leading-relaxed text-[#333333]">
                We may update these Terms from time to time. Continued use of the website means you accept any updated Terms.
              </p>
            </section>

            <div className="mt-16 bg-gray-50 border-2 border-gray-200 p-8 rounded-2xl">
              <h3 className="text-2xl font-semibold text-black mb-4">
                Questions?
              </h3>
              <p className="text-base md:text-lg leading-relaxed text-[#333333] mb-3">
                If you have questions about these Terms of Use, please contact us at:
              </p>
              <a 
                href="mailto:hello@youraiatlas.com" 
                className="text-base md:text-lg text-[#0044CC] hover:underline"
              >
                hello@youraiatlas.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TermsPage;